/*
 * File: d:\projects\AutoFiFront\src\Content\SVG\BrandSVG\HONDA.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday March 10th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday March 10th 2023 5:11:21 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { SVGProps } from 'Content/SVG/SVGProps';

function HONDA(props: SVGProps) {
    return(
        <svg id="Calque_1" fill={props.fill} data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080">
            <path d="M540.03,627.27c-7.18,0-14.41,.38-20.11,1.15-27.05,3.64-37.19,10.67-46.72,28.63-6.18,11.58-18.57,46.67-28.48,91.38-19.4-.68-38.79-1.64-58.16-2.87-6.75-62.81-22.31-324.22-22.74-413.93,10.96-.72,22.59-1.68,35.42-2.2,7.75,41.46,33.6,185.93,54.76,231.36,9.38,20.25,25.75,27.14,45.81,28.67,26.81,1.39,53.66,1.39,80.47,0,20.01-1.53,36.38-8.43,45.76-28.67,21.11-45.43,46.96-189.85,54.76-231.36,12.83,.57,24.51,1.48,35.42,2.2-.43,89.76-15.94,351.13-22.79,413.93-17.33,1.15-37.34,2.11-58.16,2.87-9.91-44.76-22.31-79.8-28.48-91.38-9.48-17.95-19.63-24.99-46.72-28.63-6.65-.81-13.35-1.19-20.06-1.15"/>
            <path d="M540.03,816.35c-53.95,0-177.26-3.3-217.86-10.91-43.13-8.09-72.24-32.84-86.5-73.53-12.21-34.71-21.21-99.14-26.76-191.53-3.45-57.87-3.4-109.86,.14-154.38,6.13-75.78,41.12-105.98,114.31-114.27,48.92-5.46,158.26-8.09,216.66-8.09s167.74,2.63,216.56,8.14c73.19,8.28,108.23,38.49,114.31,114.27,3.59,44.52,3.64,96.51,.19,154.38-5.51,92.39-14.5,156.82-26.71,191.53-14.31,40.69-43.37,65.39-86.6,73.53-40.45,7.56-163.81,10.87-217.76,10.87h0Zm211.63-43.85c28.05-5.28,51.27-24.91,61.13-51.7,7.66-21.88,18.24-71.23,24.89-182.48,3.4-56.34,3.35-106.7-.14-149.69-4.12-51.41-30.06-77.45-84.68-83.63-47.58-5.36-155.15-7.85-212.83-7.85s-165.25,2.49-212.88,7.9c-54.57,6.18-80.52,32.22-84.68,83.63-3.45,42.99-3.45,93.35-.1,149.69,6.65,111.25,17.23,160.56,24.89,182.48,7.37,20.97,27.96,45.43,61.08,51.7,34.13,6.37,146.29,10.34,211.68,10.34s177.5-3.97,211.63-10.39"/>
        </svg>
    );
}

export default HONDA;
